export default __webpack_public_path__ + "static/media/icon-delete.068ab53f.svg";